/* eslint-disable no-console */
const noop = () => {};

const logger = {
  error: process.env.NODE_ENV !== 'production' ? console.error.bind(console) : noop,
  warn: process.env.NODE_ENV !== 'production' ? console.warn.bind(console) : noop,
};

export default logger;
